import { useEffect } from "react";
import "./App.css";
import Navigate from "./Navigates/Navigate";
import { ThemeProvider } from "@mui/material";
import createAppTheme, { loadFonts } from "./theme";
import "react-toastify/dist/ReactToastify.min.css";

function App() {
  const theme = createAppTheme();
  useEffect(() => {
    loadFonts();
  }, []);
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Navigate />
      </ThemeProvider>
    </div>
  );
}
export default App;
